import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-tabination',
  templateUrl: './tabination.component.html',
  styleUrls: ['./tabination.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TabinationComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }

  ngOnDestroy() {
  }
}



// WEBPACK FOOTER //
// ./src/app/features/tabination/tabination.component.ts